import React from 'react';
import TableData from './components/ticketTable';
const index = () => {
  return (
    <div>
      <TableData />
    </div>
  );
};

export default index;
